import { Observable, lastValueFrom, firstValueFrom, take } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Cookie } from 'ng2-cookies';
import { PusherService } from 'app/modules/shared/services/pusher.service';
import { environment } from 'environments/environment';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { HttpClient } from '@angular/common/http';
import { Select, Store } from '@ngxs/store';
import { GetLenderUser } from 'app/store/lender-user/lender-user/lender-user.actions';
import { AuthenticationService } from './authentication.service';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';

declare let window;

interface LoginResponse {
  status: string;
  data: {
    access_token: string;
    expires: number;
    role: string;
  };
}

@Injectable()
export class SessionService {

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

  user: LenderUser;
  private lendioDomain = '.lendio.com';

  constructor(
    private http: HttpClient,
    private api: ApiHttpClient,
    private pusherService: PusherService,
    private store: Store,
    private authSerivce: AuthenticationService
  ) { }

  async login(email: string, password: string, type: string) {
    // perform auth request
    const data = `username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`;
    const request$ = this.http
      .post<LoginResponse>(`${environment.API_URL}/authorization/${type}`, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          // eslint-disable-next-line max-len
          Authorization: 'Basic OGZkYmZlNDk4NGU5ODEwMGUzYjAwM2ViMTk1ZjA2NWM0YzY2N2U3Mzo4ZTc3MTVlMzYwNmRjZWU5Y2E2NWUzYTQ3YzM4NjFiMjFkNDAxMmY2'
        }
      });
    const response = await firstValueFrom(request$);

    if (response.status !== 'success' || !response.data?.access_token) {
      throw new Error('Login failed.');
    }

    // set auth cookies
    const domain = window.location.hostname.includes('.lendio.com')
      ? '.lendio.com'
      : window.location.hostname;
    const isSecure = environment.environment === 'staging' || environment.environment === 'LIVE';
    Cookie.set('auth_token', response.data.access_token, undefined, undefined, domain, isSecure);
    Cookie.set('auth_expires', response.data.expires.toString(), undefined, undefined, domain);
    Cookie.set('userType', response.data.role || 'lender');
    this.store.dispatch(new GetLenderUser());
  }

  async logout() {
    // update user record
    this.lenderUser$.pipe(take(1)).subscribe(user =>{
      this.user = user;
    });
    await lastValueFrom(this.api.put(`lender-user/${this.user.id}`, { lastLogout: 1 }));
    const domain = window.location.hostname.includes(this.lendioDomain) ?
      this.lendioDomain : window.location.hostname;

    // clear cookies
    Object.keys(Cookie.getAll())
      .filter(key => key !== 'use_login_form')
      .forEach(key => Cookie.delete(key, '/', domain));

    if (localStorage) {
      localStorage.clear();
    }

    // Leave any pusher channels the user is subscribed to
    this.pusherService.unsubscribeAll();

    // Clear js-data lender user cache
    this.authSerivce.redirectToAuthenticate();
  }
}
